import script from "./EditDeductionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDeductionPage.vue?vue&type=script&setup=true&lang=js"

import "./EditDeductionPage.vue?vue&type=style&index=0&id=2454b220&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2454b220"]])

export default __exports__